<template>
  <div class="row photo-card">
    <div class="col-lg-9">
      <div class="image-wrapper" @click="$photoswipe.open(photo.i, slides)">
        <review-photo :photo="photo"/>
      </div>
      <!--.image-wrapper -->
    </div>
    <!--.col -->
    <div class="col-lg-3">
      <h5 class="text-muted font-weight-light">{{photo.title}}</h5>
      <p class="font-italic small text-muted">{{photo.year}}</p>
      <p>{{photo.description}}</p>
    </div>
    <!--.info -->
  </div>
  <!--.row -->
</template>

<script>
import ReviewPhoto from '@/components/review/ReviewPhoto.vue'
export default {
  props: ['photo', 'slides'],
  components: { ReviewPhoto }
}
</script>

<style scoped>
.photo-card {
  margin-bottom: 2.5em;
  margin-top: 2.5em;
  padding-bottom: 2.5em;
  border-bottom: 1px solid #dce1e6d6;
}
.image-wrapper {
  cursor: zoom-in;
}
</style>
